import React from 'react'
import { Empty, Spin } from 'antd'
import type { MemberListFilters, Organization } from '../types'
import MemberTableHead from './MemberTable/MemberTableHead'
import MemberTableScroll from './MemberTable/MemberTableScroll'

interface MemberTableStateProps {
  description?: string
  loading?: boolean
  organizations?: Organization[]
  roleOrganizations?: Organization[]
  showOrganizationFilter?: boolean
  filters?: MemberListFilters
  onFiltersChange?: (filters: MemberListFilters) => void
}

const MemberTableState: React.FC<MemberTableStateProps> = ({
  description,
  loading,
  organizations,
  roleOrganizations,
  showOrganizationFilter,
  filters,
  onFiltersChange,
}) => (
  <div className="um-refactor__table-wrap">
    <MemberTableScroll
      header={(
        <MemberTableHead
          organizations={organizations}
          roleOrganizations={roleOrganizations}
          showOrganizationFilter={showOrganizationFilter}
          filters={filters}
          onFiltersChange={onFiltersChange}
        />
      )}
    >
      <div className="um-refactor__table-state">
        {loading ? (
          <Spin />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
        )}
      </div>
    </MemberTableScroll>
  </div>
)

export default MemberTableState
